import script from "./ComparePlan.vue?vue&type=script&setup=true&lang=js"
export * from "./ComparePlan.vue?vue&type=script&setup=true&lang=js"

import "./ComparePlan.vue?vue&type=style&index=0&id=5c1d3495&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c1d3495"]])

export default __exports__